/* SP-PRICE-VIEW (14.10.2026, Board 235 Variante C) – Preis-Kette fürs Textil unter der Datenzeile + aufgeschlüsselte Bestellung
   als Tabelle in Schritt 4. Rechnet wie calc() in assets/sp-pdp-neu.js (Varianten-, Technik- und Positionspreise brutto,
   Staffel aus data.tiers) und gleicht mit „Gesamt inkl. MwSt.“ der Seite ab. Netto = brutto / 1,19.
   Doku + Texte (DE/EN): sections/sp-logo-preview.liquid, Block SP-PRICE-VIEW. Stil: assets/sp-price-view.css */
(function () {
  'use strict';
  var VAT = 1.19, T = null;
  function mk(tag, cls, txt) { var d = document.createElement(tag); if (cls) d.className = cls; if (txt != null) d.textContent = txt; return d; }
  function eur(c) { return (Math.round(c) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function cents(t) { var m = String(t || '').replace(/[^0-9,]/g, '').replace(',', '.'); return Math.round(parseFloat(m || '0') * 100); }
  function net(c) { return Math.round(c / VAT); }
  function tp(s, x) { return String(s || '').replace('{x}', x); }

  function kind(title) {
    var k = T.kinds || {}, t = String(title || '');
    if (/polo/i.test(t)) return k.polo;
    if (/t-?shirt|\btee\b/i.test(t)) return k.tshirt;
    if (/hoodie/i.test(t)) return k.hoodie;
    return k.other;
  }
  function tr(l) {
    if (!T.en) return l;
    var t = window.spI18nEn && window.spI18nEn.tr ? window.spI18nEn.tr(l) : l;
    return t !== l ? t : ((T.lbl || {})[l] || l);
  }

  function init(el) {
    if (el.dataset.sppv) return true;
    var st = el.spnState, node = el.querySelector('[data-spn-data]');
    var facts = el.querySelector('.spn-facts2'), sum = el.querySelector('.spn-sum'), lines = sum && sum.querySelector('.spn-lines');
    if (!st || !node || !el.dataset.spnReady || !facts || !lines) return false;
    var tn = document.querySelector('[data-sppv-txt]');
    try { T = JSON.parse(tn.textContent); } catch (e) { return true; }
    el.dataset.sppv = '1';
    var D = null, DL = -1, VM = {};
    function data() {
      var s = node.textContent;
      if (s.length !== DL) {
        try { D = JSON.parse(s); } catch (e) { return D; }
        DL = s.length; VM = {};
        (D.variants || []).forEach(function (v) { VM[v.color + '|' + v.size] = v; });
      }
      return D;
    }

    /* Modell wie in sp-pdp-neu.js: Aris-Optionssatz (el.spnAris), sonst feste Werte aus charges/charges2 */
    function model(i) {
      var A = el.spnAris;
      if (A && A.length) return A[i] || A[0];
      var d = data(), ch = (i === 0 ? d.charges : (d.charges2 || d.charges)) || {}, N = { price: 0 };
      var P = [['links', 'Brust links', 'front'], ['mitte', 'Brust Mitte', 'front'], ['rechts', 'Brust rechts', 'front'], ['schulter', 'Schulterblatt', 'back', 1], ['ruecken', 'Rücken komplett', 'back', 1]];
      return {
        tech: { druck: ch.druck, stick: ch.stick },
        pos: P.map(function (p) { var by = { druck: p[3] && ch[p[0]] ? ch[p[0]] : N }; if (!p[3]) by.stick = N; return { key: p[0], label: p[1], side: p[2], by: by }; })
      };
    }
    function logo(lg, i) {
      var m = model(i), p = null;
      m.pos.forEach(function (q) { if (q.key === lg.pos) p = q; });
      p = p || m.pos[0] || { by: {}, label: lg.pos, side: 'front' };
      var t = (m.tech || {})[lg.fin] || { price: 0 }, pc = (p.by || {})[lg.fin] || { price: 0 };
      var name = (T.fin[lg.fin] || lg.fin) + (T.side[p.side] ? ' ' + T.side[p.side] : '') + ' · ' + tr(p.label || lg.posLabel || lg.pos);
      return { name: name, price: (t.price || 0) + (pc.price || 0) };
    }
    function calc() {
      var d = data(), pieces = 0, goods = 0, min = null;
      (d.variants || []).forEach(function (v) { if (v.available !== false && (min === null || v.price < min)) min = v.price; });
      if (min === null) min = Math.min.apply(null, (d.variants || []).map(function (v) { return v.price; }));
      st.sel.forEach(function (n) {
        var q = st.qty[n] || {};
        (d.sizes || []).forEach(function (s) { var v = VM[n + '|' + s], k = q[s] || 0; if (k && v) { pieces += k; goods += k * v.price; } });
      });
      var L = st.logos.map(logo), per = 0;
      L.forEach(function (l) { per += l.price; });
      var sub = goods + pieces * per, cur = null;
      (d.tiers || []).forEach(function (t) { if (sub >= t.minCents) cur = t; });
      var pct = cur ? cur.pct : 0, disc = Math.round(sub * pct / 100);
      return { d: d, min: min, pieces: pieces, goods: goods, logos: L, sub: sub, pct: pct, cur: cur, total: sub - disc };
    }

    /* 1 · Preis-Kette unter der Datenzeile */
    var chain = mk('section', 'sppv-chain');
    chain.setAttribute('aria-label', T.chainAria);
    var cHead = mk('p', 'sppv-chain__h'), cList = mk('ol', 'sppv-chain__list');
    chain.appendChild(cHead); chain.appendChild(cList);
    facts.parentNode.insertBefore(chain, facts.nextSibling);

    /* 2 · Tabelle in Schritt 4 */
    var wrap = mk('div', 'sppv-tbl'), tbl = mk('table');
    wrap.appendChild(tbl);
    lines.parentNode.insertBefore(wrap, lines);
    [['[data-spn-l-qty]'], ['[data-spn-l-disclabel]']].forEach(function (s) { var x = sum.querySelector(s[0]); if (x && x.parentNode) x.parentNode.classList.add('sppv-hide'); });
    sum.classList.add('sppv-on');

    function tierLbl(t) { return tp(T.from, (t.minCents / 100).toLocaleString(T.en ? 'en-GB' : 'de-DE')); }
    function cell(tag, cls, txt) { return mk(tag, cls, txt); }

    function render() {
      var r = calc(), d = r.d, K = kind(d.title);
      /* Kette */
      cHead.textContent = tp(T.chainHead, K);
      cList.innerHTML = '';
      var steps = [{ l: T.single, p: r.min, on: !r.cur }];
      (d.tiers || []).forEach(function (t) { steps.push({ l: tierLbl(t), p: r.min * (100 - t.pct) / 100, on: !!(r.cur && r.cur.pct === t.pct) }); });
      steps.forEach(function (s, k) {
        if (k) { var a = mk('li', 'sppv-chain__arr', '→'); a.setAttribute('aria-hidden', 'true'); cList.appendChild(a); }
        var li = mk('li', 'sppv-chip' + (s.on ? ' is-on' : ''));
        if (s.on) li.setAttribute('aria-current', 'true');
        li.appendChild(mk('span', 'sppv-chip__l', s.l));
        li.appendChild(mk('span', 'sppv-chip__p', eur(net(s.p))));
        cList.appendChild(li);
      });

      /* Tabelle */
      var pageSub = cents((sum.querySelector('[data-spn-l-sub]') || {}).textContent);
      var pageTot = cents((sum.querySelector('[data-spn-l-total]') || {}).textContent);
      var ok = r.pieces > 0 && pageSub === r.sub && pageTot === r.total;
      wrap.hidden = !ok;
      sum.classList.toggle('sppv-on', ok);
      el.dataset.sppvCheck = r.pieces ? (ok ? 'ok' : 'diff ' + r.sub + '/' + pageSub) : 'empty';
      if (!ok) return;
      var f = (100 - r.pct) / 100, N = r.pieces, rows = [];
      rows.push({ n: K, list: r.goods / N, gross: r.goods });
      r.logos.forEach(function (l) { rows.push({ n: l.name, list: l.price, gross: l.price * N }); });
      var netTot = net(r.total), rest = netTot;
      rows.forEach(function (x, k) { if (k) { x.tot = Math.round(x.gross * f / VAT); rest -= x.tot; } });
      rows[0].tot = rest;
      var listSum = 0;
      rows.forEach(function (x) { listSum += x.list; });
      rows.push({ n: tp(T.complete, K), list: listSum, tot: netTot, all: 1 });

      tbl.innerHTML = '';
      tbl.className = r.pct ? 'has-disc' : '';
      var th = mk('thead'), hr = mk('tr');
      hr.appendChild(cell('th', 'sppv-c-n', T.perPiece));
      hr.appendChild(cell('th', 'sppv-c-l', T.list));
      if (r.pct) hr.appendChild(cell('th', 'sppv-c-d', tp(T.withDisc, r.pct)));
      hr.appendChild(cell('th', 'sppv-c-t', '× ' + N.toLocaleString('de-DE')));
      [].forEach.call(hr.children, function (c) { c.setAttribute('scope', 'col'); });
      th.appendChild(hr); tbl.appendChild(th);
      var tb = mk('tbody');
      rows.forEach(function (x) {
        var tr_ = mk('tr', x.all ? 'sppv-all' : '');
        var h = cell('th', 'sppv-c-n', x.n); h.setAttribute('scope', 'row'); tr_.appendChild(h);
        tr_.appendChild(cell('td', 'sppv-c-l', eur(x.list / VAT)));
        if (r.pct) tr_.appendChild(cell('td', 'sppv-c-d', eur(x.list * f / VAT)));
        tr_.appendChild(cell('td', 'sppv-c-t', eur(x.tot)));
        tb.appendChild(tr_);
      });
      var vr = mk('tr', 'sppv-vat'), vh = cell('th', 'sppv-c-n', T.vat);
      vh.setAttribute('scope', 'row'); vr.appendChild(vh);
      vr.appendChild(cell('td', 'sppv-c-l', ''));
      if (r.pct) vr.appendChild(cell('td', 'sppv-c-d', ''));
      vr.appendChild(cell('td', 'sppv-c-t', eur(r.total - netTot)));
      tb.appendChild(vr);
      tbl.appendChild(tb);
    }
    var q = 0;
    function sched() { if (q) return; q = setTimeout(function () { q = 0; try { render(); } catch (e) { wrap.hidden = true; sum.classList.remove('sppv-on'); } }, 0); }
    el.addEventListener('spn:change', sched);
    el.addEventListener('input', sched);
    var tot = sum.querySelector('[data-spn-l-total]');
    if (tot) new MutationObserver(sched).observe(tot, { childList: true, characterData: true, subtree: true });
    sched();
    return true;
  }

  function boot() {
    var n = 0;
    (function wait() {
      var roots = document.querySelectorAll('[data-spn-root]'), pending = !roots.length;
      Array.prototype.forEach.call(roots, function (el) { if (!init(el)) pending = true; });
      if (pending && n++ < 150) setTimeout(wait, 100);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})()